import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import {
  flex,
  color,
  space,
  width,
  order,
  zIndex,
  height,
  borders,
  display,
  maxWidth,
  position,
  fontSize,
  flexWrap,
  minWidth,
  overflow,
  boxShadow,
  minHeight,
  alignSelf,
  alignItems,
  borderRadius,
  flexDirection,
  justifyContent,
  border,
  flexBasis,
  background,
} from 'styled-system';

type Props = StyledSystemProps & {
  cursor?: string;
}

const Box = styled.div<Props>`
  ${flex};
  ${space};
  ${color};
  ${order};
  ${width};
  ${border};
  ${zIndex};
  ${height};
  ${borders};
  ${display};
  ${fontSize};
  ${maxWidth};
  ${minWidth};
  ${overflow};
  ${position};
  ${flexWrap};
  ${minHeight};
  ${alignSelf};
  ${boxShadow};
  ${alignItems};
  ${borderRadius};
  ${flexDirection};
  ${justifyContent};
  ${flexBasis};
  ${background};
  cursor: ${props => props.cursor || 'default'}
  box-sizing: border-box;
`;

export default Box;

Box.defaultProps = {
  display: 'flex',
  maxWidth: '100%',
  position: 'relative',
  flexDirection: 'column',
};



// WEBPACK FOOTER //
// ./src/components/primitives/Box.tsx